import { AuthException } from "./auth.exception";

export class EmailsDoNotMatchException extends AuthException {
  constructor() {
    super("errors.auth.emails.do.not.match", "Email entered does not match current email");
  }
}
